import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { Trans } from '@lingui/react';
import gql from 'graphql-tag';
import Stickable from '../../components/Stickable';
import LinksVideos from './LinksVideos';
import { VIDEOS_GENRES_ID } from '@lib/constants';

const GET_PRIMARY_LINKS = gql`
  query taxonomies($filter: String) {
    taxonomies(filter: $filter) {
      terms {
        id
        name
        slug
      }
    }
  }
`;

const order = ['yoga', 'meditation', 'breathing', 'workout', 'grow'];
const VideosSubheader = () => {
  const { error, loading, data } = useQuery(GET_PRIMARY_LINKS, {
    variables: { filter: VIDEOS_GENRES_ID },
  });

  const sortedTaxonomies = useMemo(() => {
    if (data?.taxonomies) {
      const { taxonomies } = data;
      return (
        [...taxonomies[0]?.terms]?.sort((a, b) => {
          return order.indexOf(a.slug) > order.indexOf(b.slug) ? 1 : -1;
        }) || []
      );
    }
    return [];
  }, [data?.taxonomies?.[0]?.terms]);

  return (
    <Stickable scrollAfterY={77}>
      {showSticky => {
        if (error) return null;
        if (loading) {
          return <LinksVideos showSticky={showSticky} loading={loading} />;
        }

        return (
          <LinksVideos
            showSticky={showSticky}
            terms={[
              {
                id: 'all',
                name: <Trans id="metadata.all" message="All" />,
                slug: 'all',
              },
              ...sortedTaxonomies,
            ]}
          />
        );
      }}
    </Stickable>
  );
};

export default VideosSubheader;
